import React, { Key, useState } from "react";
import { ILinkFunc } from "../../lib/util";
import { IListing, IListingSummary } from "../../lib/Listing";
import {
  WsrvImage,
  IWsrvImageProps,
} from "../Media";
import { EWsrvTransform } from "../../lib";
import { Button } from "../Button";
import PlayButton from "../../static/play-button.svg";
import truncate from "truncate-html";

export interface IListing3DToursProps {
  media?: React.ReactNode;
  listing: IListing;
  linkFunc?: ILinkFunc;
  linkText?: string;
  className?: string;
  maxWidthImage?: number;
  imageProps?: Partial<IWsrvImageProps>;
  imageClassProps?: string;
  keyIndex?: Key | null | undefined;
  style?: React.CSSProperties;
}
export const Listing3DTours: React.FC<IListing3DToursProps> = ({
  listing,
  imageProps,
  maxWidthImage,
  imageClassProps,
  media,
  className,
  style,
  keyIndex,
  linkText,
  linkFunc,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const modalClass = modalOpen ? "flex" : "hidden";

  let image: React.ReactNode =
    media ||
    (listing.defaultImage && (
      <WsrvImage
        urlParams={{
          originURL: listing.defaultImage.url,
          preset: EWsrvTransform.cover3x2,
          width: maxWidthImage,
        }}
        widthMax={maxWidthImage}
        imgProps={{
          className: imageClassProps,
          width: listing.defaultImage.dimensions?.[0],
          height: listing.defaultImage.dimensions?.[1],
          placeholder: <span style={undefined} />,
          wrapperProps: {
            style: {},
          },
          alt: listing.defaultImage.caption || listing.address?.text,
        }}
        {...imageProps}
      />
    ));
  return (
    <div
      className={`listing-3dcard relative sm:flex ${className} relative`}
      key={keyIndex}
      style={style}
    >
      <div className="w-full px-0 md:px-4">
        <div onClick={openModal} className="relative w-345 h-229 px-10 sm:px-6 md:px-0">
          <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center cursor-pointer">
            <img src={PlayButton} alt="tour" />
          </div>
          {image}
        </div>
        <div className="text-center text-2xl">{listing.address?.street1}</div>
        <div className="text-center text-14" dangerouslySetInnerHTML={{ __html: listing.description ? truncate(listing.description, 250) : "" }}>
        </div>
        <div>
          {linkText && (
            <div className="text-center ">
              <Button
                linkProps={{ href: listing.path, className: "border-0 button" }}
                icon={false}
                line={true}
                linkFunc={linkFunc}
              >
                {linkText}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div
        className={`fixed inset-0 z-50 w-screen h-screen bg-[rgba(0,0,0,0.8)] justify-center items-center ${modalClass}`}
      >
        <div
          onClick={closeModal}
          className={`absolute 
                      right-10 top-1 text-[#999] 
                      opacity-[0.2] text-[35px] 
                      font-bold [text-shadow:_0_1px_0_rgb(255px_255px_255px)] font-sans cursor-pointer`}
        >
          x
        </div>
        <iframe
          src={listing.tours?.[0]?.url}
          allowFullScreen
          className="border-2 border-white w-[296px] h-[190px] sm:h-[290px] sm:w-[470px] md:w-[676px] md:h-[410px] lg:w-[976px] lg:h-[546px]"
        ></iframe>
      </div>
    </div>
  );
};

export default Listing3DTours
